<template>
  <div>
    <layout-loading v-if="isSubmit" />
    <BDataTable
      ref="refTable"
      :fetch-list="fetchList"
      :table-columns="tableColumns"
      :table-attr="tableAttr"
      :filters="filters"
      @onGroupDelete="groupDelete"
    >
      <template #leftHeader>
        <b-col>
          <b-form-group class="mb-0">
            <v-select-custom
              v-model="role"
              :options="roleOptions"
            />
          </b-form-group>
        </b-col>
      </template>
      <!-- Column: fullName -->
      <template #cell(fullName)="data">
        <b-link
          :to="{ name: 'pages-users-edit', params: { id: data.item._id } }"
          class="d-flex align-items-center justify-content-center"
        >
          <span class="d-inline-block w-30">
            <feather-icon
              v-if="data.item.isBlocked"
              v-b-tooltip
              icon="LockIcon"
              color="indianred"
              size="22"
              :title="$t('users.blocked')"
              class="mr-1"
            />
          </span>
          {{ data.item.fullName }}
        </b-link>
      </template>

      <!-- Column: PhoneNumber -->
      <template #cell(phoneNumber)="data">
        <span class="d-inline-block w-30">
          <feather-icon
            v-if="data.item.isVerifiedPhoneNumber"
            v-b-tooltip
            icon="PocketIcon"
            color="#5ad05a"
            size="22"
            :title="$t('users.isVerifiedPhoneNumber')"
            class="mr-1"
          />
        </span>
        <span class="text-dark">{{ data.item.phoneNumber.slice(1) }}</span>
      </template>

      <!-- Column: isDeactivate -->
      <template #cell(isDeactivate)="data">
        <span class="align-text-top">{{
          data.item.isDeactivate ? $t(`users.deactivated`) : ""
        }}</span>
      </template>

      <!-- Column: Role -->
      <template #cell(roles)="data">
        <div
          v-for="(role, index) in data.item.roles"
          :key="index"
          class="text-nowrap"
        >
          <feather-icon
            :icon="resolveUserRoleIcon(role)"
            size="18"
            class="mr-50"
            :class="`text-${resolveUserRoleVariant(role)}`"
          />
          <span class="align-text-top">{{ role }}</span>
        </div>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="{ item }">
        <edit-row @click.native="toEditPage(item._id)" />
        <delete-row v-if="$can('delete', 'user') && ($can('manage', 'all') || ordinaryAccount(item.roles))" @click.native="deleteItem(item._id)" />
      </template>
    </BDataTable>
  </div>
</template>

<script>
import {
  BLink, VBTooltip, BCol, BFormGroup,
} from 'bootstrap-vue'
import BDataTable from '@/components/BDataTable/index.vue'
import DeleteRow from '@/components/BDataTable/Actions/DeleteRow.vue'
import EditRow from '@/components/BDataTable/Actions/EditRow.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import VSelectCustom from '@/components/VSelectCustom/index.vue'
import useUsersList from './useUsersList'
import { ordinaryAccount } from './maintenance-authority'

export default {
  name: 'UsersList',
  components: {
    BCol,
    BDataTable,
    BFormGroup,
    BLink,
    DeleteRow,
    EditRow,
    LayoutLoading,
    VSelectCustom,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  setup() {
    const {
      currentLanguage,
      deleteItem,
      fetchList,
      fetchUserRoles,
      groupDelete,
      isSubmit,
      refTable,
      resolveUserRoleIcon,
      resolveUserRoleVariant,
      role,
      roleOptions,
      roles,
      tableColumns,
      toEditPage,
    } = useUsersList()
    return {
      currentLanguage,
      deleteItem,
      fetchList,
      fetchUserRoles,
      groupDelete,
      isSubmit,
      refTable,
      resolveUserRoleIcon,
      resolveUserRoleVariant,
      role,
      roleOptions,
      roles,
      tableColumns,
      toEditPage,
    }
  },
  computed: {
    tableAttr() {
      return { striped: false, 'tbody-tr-class': this.rowClass }
    },
    filters() {
      return { role: this.role }
    },
  },
  watch: {
    role() {
      this.refTable.refetchData()
    },
  },
  created() {
    this.fetchUserRoles()
  },
  methods: {
    ordinaryAccount,
    rowClass(item, type) {
      if (!item || type !== 'row') return undefined
      if (item.isDeactivate) return 'opacity-60'
      return undefined
    },
  },
}
</script>
